import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shop/content/index.tsx");
